import { MathPickerContribution, MathTextPicker } from "../constants";

import { DefaultMathTextPicker } from "./text-picker";

let loadTextPick = !1;

export function bindTextMathPickerContribution(container) {
    loadTextPick || (loadTextPick = !0, container.bind(MathTextPicker).toDynamicValue((() => new DefaultMathTextPicker)).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathTextPicker));
}
//# sourceMappingURL=text-module.js.map
